<template>
  <div class="order">
    <van-nav-bar title="通知发布" left-arrow @click-left="$router.go(-1)" />
    <!-- 选择家长或老师 -->
    <div class="access_box">
      <van-cell title="选择家长" icon="/img/parents.png" is-link @click="selectUser(2)" />
      <van-cell title="选择老师" icon="/img/teacher.png" is-link @click="selectUser(1)" />
    </div>
    <h5 style="padding: 10px 20px;">名单详情</h5>
    <div class="name_list" v-if="teachers.length > 0 || parents.length > 0">
      <div v-if="parents.length">
        <h5>家长名单</h5>
        <span style="margin-left: 20px;"></span>
        <span style="font-size: 12px;" v-for="(item, index) in parents" :key="index">{{ item.realname }}{{ index <
          parents.length - 1 ? ',' : '' }}</span>
      </div>
      <div v-if="teachers.length">
        <h5>老师名单</h5>
        <span style="margin-left: 20px;"></span>
        <span style="font-size: 12px;" v-for="(item, index) in teachers" :key="index">{{ item.realname }}{{ index <
          teachers.length - 1 ? ',' : '' }}</span>
      </div>
    </div>
    <h5 style="padding: 10px 20px;">通知内容</h5>
    <van-field v-model="noticeContent" placeholder="请输入通知内容" rows="3" autosize type="textarea" maxlength="500"
      show-word-limit clearable />
    <div class="btn_box">
      <van-button round size="normal" type="info" block @click="publishNotice">发布</van-button>
    </div>
  </div>
</template>

<script>

import { teacherPublishNotice } from '@/api/teacher'
export default {
  name: 'AccessRecord',
  components: {

  },
  data() {
    return {
      currentClass: {},
      noticeContent: '',
      teachers: [],
      parents: []
    }
  },
  mounted() {
    this.currentClass = JSON.parse(localStorage.getItem('currentClass'))
    //从缓存里获取名单
    const selectedTeachers = JSON.parse(localStorage.getItem('selectedTeachers'))
    if (selectedTeachers) {
      this.teachers = selectedTeachers
    }
    const selectedParents = JSON.parse(localStorage.getItem('selectedParents'))
    if (selectedParents) {
      this.parents = selectedParents
    }
  },
  methods: {
    selectUser(type) {
      if (type == 1) {
        this.$router.push({ path: '/selectteacher' })
      } else if (type == 2) {
        this.$router.push({ path: '/selectparents', query: { classname: this.currentClass.name } })
      }
    },
    async publishNotice() {
      if (this.noticeContent.trim() == '') {
        this.$toast('请输入通知内容')
        return
      }
      if (this.teachers.length == 0 && this.parents.length == 0) {
        this.$toast('请选择接收人')
        return
      }
      //发布通知
      const payload = {
        content: this.noticeContent,
        teachers: this.teachers.map(item => item.id),
        parents: this.parents.map(item => item.id)
      }
      let res = await teacherPublishNotice(payload)
      console.log('发布通知结果', res);
      if (res.code == 10000) {
        this.$toast.success('通知成功，返回上一页')
        //清空缓存
        localStorage.removeItem('selectedTeachers')
        localStorage.removeItem('selectedParents')
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      }
    }
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}

.van-tabs {
  position: sticky;
  top: 0;
}

.name_list {
  background-color: #e4e8e9;
  color: #000000;
  width: 100%;
  font-size: 14px;
  padding: 10px 10px;
}

.access_box {
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;
}

.btn_box {
  padding: 20px 10px;
}
</style>
